module.exports = __webpack_public_path__ + "img/f59b1a6.jpg";